import { Profile } from '@news-mono/web-common'
import React from 'react'
import {
    StyledBylineFooter,
    StyledBylineHeading,
    StyledBylineSubHeading,
    StyledBylineWrapper,
    StyledBylineHeadingLink,
    StyledBylineContainer,
    BylineFundingTypeWrapper,
} from './Byline.styled'
import { getProfileLink } from '../../helpers/getProfileLink'
import { Bullet } from '../../../../cards/TheNightly/components'
import { CommentButtonTN } from '../../../../coral/CommentButtonTN'
import { getReadTimeForDisplay } from '../../../../__helpers/get-read-time'
import { FundingLabel } from '../../../../advertising/FundingLabel/FundingLabel'
import { FundingType } from '../../../../templates'
import { isMobileViewport } from '../../../../__helpers'
import { PublishedTime } from '../../../../cards/TheNightly/components/card-body/PublishedTime'

type BylineTextProps = {
    profile: Profile[] | undefined
    source: string | undefined
    timestamp?: string | undefined
    text: string | undefined
    isContentPartner: boolean
    allowCommenting: boolean
    url?: string
    topic?: string
    readTimeMinutes?: number
    isLink?: boolean
    fundingType?: FundingType | undefined
}
export const BylineText: React.FC<BylineTextProps> = ({
    profile,
    source,
    timestamp,
    text,
    allowCommenting,
    url,
    topic,
    readTimeMinutes,
    isLink,
    fundingType,
}) => {
    const profileLink = profile && getProfileLink(profile)
    const isMobile = isMobileViewport()

    /**                   ↓----Byline Text----↓
     *  |~~~~~~~~~~~|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|~~~~~~~~~~~~~~~|
     *  | profile   |   Top Row // Name             |               |
     *  | pic       |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *  |           |   Middle Row // Publisher     |               |
     *  |___________|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *              |   Bottom Row // Min read/Date |               |
     *              |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|_______________|
     */

    return (
        <StyledBylineContainer>
            <StyledBylineWrapper>
                {/* Use a clickable link if one exists for the profile */}
                {profileLink && isLink ? (
                    <StyledBylineHeadingLink to={profileLink}>
                        {text}
                    </StyledBylineHeadingLink>
                ) : (
                    <StyledBylineHeading>{text}</StyledBylineHeading>
                )}
                {source && (
                    <StyledBylineSubHeading>{source}</StyledBylineSubHeading>
                )}
                <BylineFundingTypeWrapper>
                    <StyledBylineFooter>
                        {topic}
                        {readTimeMinutes !== undefined && (
                            <span>
                                {getReadTimeForDisplay(readTimeMinutes)} Min
                                Read
                            </span>
                        )}
                        {(readTimeMinutes || topic) && timestamp && <Bullet />}
                        {timestamp && (
                            <PublishedTime publicationDate={timestamp} />
                        )}
                    </StyledBylineFooter>
                    {fundingType && (
                        <FundingLabel
                            fundingType={fundingType}
                            linkToDisclaimer={true}
                        />
                    )}
                </BylineFundingTypeWrapper>
            </StyledBylineWrapper>
            {allowCommenting && (
                <StyledBylineWrapper>
                    <CommentButtonTN url={url} />
                </StyledBylineWrapper>
            )}
        </StyledBylineContainer>
    )
}
